export default __webpack_public_path__ + "static/media/single_customer_view_img.b253db0f.png";